module.exports = __webpack_public_path__ + "static/media/mobiezy1.c5d25119.png";